import React, { useRef, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, FieldArray, Form as FormikForm, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { AiOutlineDelete } from 'react-icons/ai';
import successToast from '../../toasts/successToast';
import CustomCheckboxDropdown from '../../forms/checkBoxDropDown';

const teams = [
    { id: 1, name: 'Team Alpha' },
    { id: 2, name: 'Team Bravo' },
    { id: 3, name: 'Team Charlie' },
];

const targetLanguages = [
    { value: 'en', label: 'English (US)' },
    { value: 'am', label: 'Amharic' },
    { value: 'ar', label: 'Arabic' },
    { value: 'eu', label: 'Basque' },
    { value: 'bn', label: 'Bengali' },
    { value: 'en-GB', label: 'English (UK)' },
    { value: 'pt-BR', label: 'Portuguese (Brazil)' },
    { value: 'bg', label: 'Bulgarian' },
    { value: 'ca', label: 'Catalan' },
    { value: 'chr', label: 'Cherokee' },
    { value: 'hr', label: 'Croatian' },
    { value: 'cs', label: 'Czech' },
    { value: 'da', label: 'Danish' },
    { value: 'nl', label: 'Dutch' },
    { value: 'et', label: 'Estonian' },
    { value: 'fil', label: 'Filipino' },
    { value: 'fi', label: 'Finnish' },
    { value: 'fr', label: 'French' },
    { value: 'de', label: 'German' },
    { value: 'el', label: 'Greek' },
    { value: 'gu', label: 'Gujarati' },
    { value: 'iw', label: 'Hebrew' },
    { value: 'hi', label: 'Hindi' },
    { value: 'hu', label: 'Hungarian' },
    { value: 'is', label: 'Icelandic' },
    { value: 'id', label: 'Indonesian' },
    { value: 'it', label: 'Italian' },
    { value: 'ja', label: 'Japanese' },
    { value: 'kn', label: 'Kannada' },
    { value: 'ko', label: 'Korean' },
    { value: 'lv', label: 'Latvian' },
    { value: 'lt', label: 'Lithuanian' },
    { value: 'ms', label: 'Malay' },
    { value: 'ml', label: 'Malayalam' },
    { value: 'mr', label: 'Marathi' },
    { value: 'no', label: 'Norwegian' },
    { value: 'pl', label: 'Polish' },
    { value: 'pt-PT', label: 'Portuguese (Portugal)' },
    { value: 'ro', label: 'Romanian' },
    { value: 'ru', label: 'Russian' },
    { value: 'sr', label: 'Serbian' },
    { value: 'zh-CN', label: 'Chinese (PRC)' },
    { value: 'sk', label: 'Slovak' },
    { value: 'sl', label: 'Slovenian' },
    { value: 'es', label: 'Spanish' },
    { value: 'sw', label: 'Swahili' },
    { value: 'sv', label: 'Swedish' },
    { value: 'ta', label: 'Tamil' },
    { value: 'te', label: 'Telugu' },
    { value: 'th', label: 'Thai' },
    { value: 'zh-TW', label: 'Chinese (Taiwan)' },
    { value: 'tr', label: 'Turkish' },
    { value: 'ur', label: 'Urdu' },
    { value: 'uk', label: 'Ukrainian' },
    { value: 'vi', label: 'Vietnamese' },
    { value: 'cy', label: 'Welsh' },
];

const validationSchema = Yup.object({
    assignedTeams: Yup.array().of(
        Yup.object({
            team: Yup.string().required('Team is required'),
            targetLanguage: Yup.array().min(1, 'At least one Target Language is required'),
            comments: Yup.string().required('Comments is required'),
            target_date: Yup.date().required('Target Date is required'),

        })
    ),
});

const initialValues = {
    assignedTeams: [{
        team: '',
        targetLanguage: '',
        comments: '',
        target_date: '',
    }]
};

const AssignedTeams = ({ show, handleClose }) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
                console.log('Form data', values);
                handleClose();
                successToast('Team Assignment Completed');
            }}
        >
            {({ values, handleSubmit, isValid, dirty, setFieldValue }) => (
                <Modal
                    size='lg'
                    show={show}
                    onHide={handleClose}
                    centered
                >
                    <FormikForm>
                        <FieldArray name="assignedTeams">
                            {({ push, remove }) => (
                                <>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Assign Teams</Modal.Title>
                                        <Button
                                            style={{ cursor: 'pointer', marginLeft: '60%' }}

                                            onClick={() => push({ team: '', targetLanguage: '', target_date: '', comments: '' })}
                                        >Add Team </Button>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div onClick={handleClickOutside}>
                                            {values.assignedTeams.map((_, index) => (
                                                <div key={index} className="mb-3">
                                                    <div className="d-flex flex-wrap">
                                                        <div className="text-start gap-2 mb-2 text-nowrap mx-3">
                                                            <label htmlFor={`team-${index}`} className="py-1">Team</label>
                                                            <div className="d-flex position-relative">
                                                                <Field
                                                                    name={`assignedTeams[${index}].team`}
                                                                    as="select"
                                                                    className="input-field"
                                                                    id={`team-${index}`}
                                                                    style={{ width: '20rem' }}
                                                                >
                                                                    <option value="">Select a team</option>
                                                                    {teams.map((team) => (
                                                                        <option key={team.id} value={team.name}>
                                                                            {team.name}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                            <ErrorMessage name={`assignedTeams[${index}].team`} component="div" className="text-danger mt-1 fs_12" />
                                                        </div>
                                                        <div className="text-start gap-2 mb-2 text-nowrap mx-3">
                                                            <label htmlFor={`target_date-${index}`} className="py-1">Target Date</label>
                                                            <div className="d-flex position-relative">
                                                                <Field
                                                                    name={`assignedTeams[${index}].target_date`}
                                                                    type="datetime-local"
                                                                    className="input-field"
                                                                    id={`target_date-${index}`}
                                                                    style={{ width: '20rem' }}
                                                                />
                                                            </div>
                                                            <ErrorMessage name={`assignedTeams[${index}].target_date`} component="div" className="text-danger mt-1 fs_12" />
                                                        </div>
                                                        <div className="d-flex gap-3 me-4 align-items-center">
                                                            {values.assignedTeams.length > 1 && (
                                                                <AiOutlineDelete
                                                                    style={{ width: '25px', height: '25px', color: 'red' }}
                                                                    onClick={() => remove(index)}
                                                                    className="mt-4 cursor_pointer"
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="text-start gap-3 mb-2 text-nowrap mx-3" ref={dropdownRef}>
                                                            <label htmlFor={`targetLanguage-${index}`} className="py-1">Target Language</label>
                                                            <div className="custom-dropdown">
                                                                <CustomCheckboxDropdown
                                                                    options={targetLanguages}
                                                                    name={`assignedTeams[${index}].targetLanguage`}
                                                                    value={values.assignedTeams[index].targetLanguage}
                                                                    onChange={(field, value) => setFieldValue(field, value)}
                                                                    placeholder={'Select Target Language'}
                                                                    dropdownOpen={dropdownOpen}
                                                                    setDropdownOpen={setDropdownOpen}
                                                                />
                                                            </div>
                                                            <ErrorMessage name={`assignedTeams[${index}].targetLanguage`} component="div" className="text-danger mt-1 fs_12" />
                                                        </div>
                                                        <div className="text-start gap-2 mb-2 text-nowrap mx-3">
                                                            <label htmlFor={`comments-${index}`} className="py-1">Comments</label>
                                                            <div className="d-flex position-relative">
                                                                <Field
                                                                    name={`assignedTeams[${index}].comments`}
                                                                    as="textarea"
                                                                    className="input-field"
                                                                    id={`comments-${index}`}
                                                                    style={{ width: '20rem' }}
                                                                />
                                                            </div>
                                                            <ErrorMessage name={`assignedTeams[${index}].comments`} component="div" className="text-danger mt-1 fs_12" />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>
                                        <Button variant="primary" onClick={handleSubmit} disabled={!(isValid && dirty)}>
                                            Save Changes
                                        </Button>
                                    </Modal.Footer>
                                </>
                            )}
                        </FieldArray>
                    </FormikForm>
                </Modal>
            )}
        </Formik>
    );
};

export default AssignedTeams;
